/**
 * Test-SCO-Model
 * @class service_v3sTestSco
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSco
 */
angular.module('v3sWbtPlayerApp').factory('v3sTestSco', ["v3sServiceFinder", "v3sItem", "v3sSco", function (v3sServiceFinder, v3sItem, v3sSco) {

    // instantiate the sco object
    var v3sTestSco = function (data) {
        // use the original item object constructor
        v3sSco.apply(this, arguments);

        this.childrenIncludeFilter = [this.ScormDataEnum.SCORE];
        this.overwriteOnUpdate = false;

        //zum Test-Type passendes Test-Class finden
        var v3sTest = v3sServiceFinder.get("v3sTest", this.parameters.type);

        this.test = null;
        if (!!data) {
            for (var i = 0; i < data.children.length; i++) {
                var item = data.children[i];

                if (item.type === "section") {

                    var parameters = {};
                    angular.extend(parameters, this.parameters);
                    parameters.masteryscore = this.masteryscore;

                    this.test = new v3sTest(item, parameters);
                    this.children[i] = this.test;
                } else {
                    this.children[i] = new v3sItem(item);
                }
                this.children[i].parent = this;
            }
        }
        this.updateExercisesCount();
    };

    // use the original v3sSco prototype
    v3sTestSco.prototype = new v3sSco();

    v3sTestSco.prototype.getTest = function () {
        return this.test;
    };

    v3sTestSco.prototype.update = function () {
        if (this.isTrackable() && !this.test.isRunning()) {
            v3sSco.prototype.update.call(this);
        }
    };

    v3sTestSco.prototype.setStatus = function (status, options) {
        var result = v3sSco.prototype.setStatus.call(this, status, options);

        if (this.status === "completed" && this.score === undefined) {
            this.score = 0;
            this.notifyPageChanged(true);
            this.updateLastAccess();
        }

        return result;
    };

    v3sTestSco.prototype.isLastPassed = function () {
        return this.test.isPassed();
    };

    v3sTestSco.prototype.getLastScore = function () {
        return this.test.getScore();
    };

    v3sTestSco.prototype.isLastEvaluated = function () {
        return this.test.isLastEvaluated();
    };

    v3sTestSco.prototype.getExerciseStatistic = function () {
        var statisticData = { count: 0, correct: 0, wrong: 0, score: 0 };

        statisticData.score = this.getScore();
        statisticData.count = this.test.getAllMaxExercises();
        statisticData.correct = Math.round(statisticData.count * statisticData.score / 100); 
        statisticData.wrong = statisticData.count - statisticData.correct;

        return statisticData;
    };

    v3sTestSco.prototype.getAttempt = function () {
        return this.test.getAttempt();
    };

    v3sTestSco.prototype.allowEnter = function (toPage, confirm) {
        var allow = v3sSco.prototype.allowEnter.call(this, toPage, confirm);

        if (allow) {
            allow = this.test.allowEnter(toPage, confirm);
        }

        return allow;
    };

    v3sTestSco.prototype.allowExit = function (fromPage, toPage) {
        var allow = v3sSco.prototype.allowExit.call(this, fromPage, toPage);

        if (allow && !!fromPage && fromPage.parent != this) {
            allow = this.test.allowExit(fromPage, toPage);
        }

        return allow;
    };

    v3sTestSco.prototype.getChangeCount = function () {
        var count = v3sItem.prototype.getChangeCount.call(this) * 100; // Test-Änderung soll höher bewertet sein

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if (!!child) {
                count += child.getChangeCount();
            }
        }

        return count;
    }

    return v3sTestSco;
}]);